export const translationsPreviewQuery = '*[_type == "translations"]';

export const translationsPreviewQueryProjection = `
    {
      "queryResult": {
        "nodes": *[_type == "translations"]
      }
    }
  `;
